import { Box, Typography, Button, LinearProgress } from "@mui/material";

export default function Header({
  pendingCount,
  syncStatus,
  offlineReady,
  preloadProgress,
  onOpenSettings,
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {/* Top Row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Logo */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <img src="/slowlorislogoonlyt.png" alt="Logo" style={{ height: 36 }} />
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "20px", sm: "32px" },
            }}
          >
            SLOWLORIS
          </Typography>
        </Box>

        {/* 🔔 STATUS (ONLY ONE AT A TIME) */}
        {!offlineReady ? (
        <Box>
            <Typography
            variant="body2"
            sx={{ fontWeight: "bold", color: "#E3F2FD" }}
            >
            📦 Loading Data: {preloadProgress}%
            </Typography>
            <LinearProgress
            variant="determinate"
            value={preloadProgress}
            sx={{ height: 6, borderRadius: 4 }}
            />
        </Box>
        ) : syncStatus === "syncing" ? (
        <Typography sx={{ color: "orange", fontWeight: "bold" }}>
            🔄 Syncing…
        </Typography>
        ) : pendingCount > 0 ? (
        <Typography sx={{ color: "orange", fontWeight: "bold" }}>
            ⏳ Pending Sync: {pendingCount}
        </Typography>
        ) : syncStatus === "complete" ? (
        <Typography
            sx={{
            color: "#E3F2FD",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            }}
        >
            ✅ Sync complete
        </Typography>
        ) : null}

        {/* Download Android app */}
        <Button
          size="small"
          variant="outlined"
          color="success"
          href="/downloads/scan-app.apk?v=1.8"
          download
          title="Download the Android app (.apk)"
          sx={{ minWidth: 0 }}
        >
          📱 App
        </Button>

        {/* Settings */}
        <Button size="small" variant="outlined" onClick={onOpenSettings}>
          ⚙️
        </Button>
      </Box>
    </Box>
  );
}
